(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["authenticity-warranty-disclosure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tissot-retailer-verification')) {
    class TissotRetailerVerification extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('[data-tissot-copy]');
        this.checkerLink = this.querySelector('[data-tissot-checker]');
        this.domainInput = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        this.details = this.closest('details');

        this.copyButton?.addEventListener('click', () => this.copyDomain());
        this.checkerLink?.addEventListener('click', () => this.track('tissot_verification_checker_open'));
        this.details?.addEventListener('toggle', () => {
          if (this.details.open) this.track('tissot_verification_open');
        });
      }

      async copyDomain() {
        let copied = false;

        try {
          await navigator.clipboard.writeText(this.dataset.domain);
          copied = true;
        } catch (_error) {
          this.domainInput.focus();
          this.domainInput.select();

          try {
            copied = document.execCommand('copy');
          } catch (_fallbackError) {
            copied = false;
          }
        }

        if (!copied) {
          this.status.textContent = this.dataset.copyFailedLabel;
          return;
        }

        this.copyButton.textContent = this.dataset.copiedLabel;
        this.status.textContent = this.dataset.copiedLabel;
        this.track('tissot_verification_copy');

        window.clearTimeout(this.copyResetTimer);
        this.copyResetTimer = window.setTimeout(() => {
          this.copyButton.textContent = this.dataset.copyLabel;
          this.status.textContent = '';
        }, 2500);
      }

      track(eventName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          product_handle: this.dataset.productHandle,
          product_id: this.dataset.productId,
          locale: this.dataset.locale,
        });
      }
    }

    customElements.define('tissot-retailer-verification', TissotRetailerVerification);
  }
  } catch(e) { console.error(e); }
})();

})();
